import { useState } from "react";
import { BRAND_LOGO_URL, BRAND_NAME, DEFAULT_LOGO_SIZE } from "@/constants/brand";
import { resetBrandSettings, saveBrandSettings, useBrandSettings } from "@/hooks/useBrandSettings";

export default function BrandSettingsManager() {
  const { logoSize } = useBrandSettings();
  const [draftSize, setDraftSize] = useState(logoSize);
  const [saved, setSaved] = useState(false);

  const updateSize = (size: number) => {
    const nextSize = Math.min(120, Math.max(40, size));
    setDraftSize(nextSize);
    saveBrandSettings({ logoSize: nextSize });
    setSaved(false);
  };

  const handleSave = () => {
    saveBrandSettings({ logoSize: draftSize });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const handleReset = () => {
    setDraftSize(DEFAULT_LOGO_SIZE);
    resetBrandSettings();
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="max-w-3xl space-y-6">
      <div className="bg-white rounded-xl border border-alvinegro-border p-6">
        <div className="flex items-start justify-between gap-4 mb-6">
          <div>
            <h3 className="font-semibold text-alvinegro-black">Logomarca</h3>
            <p className="text-sm text-alvinegro-muted mt-1">
              Ajuste o tamanho da logo exibida no site.
            </p>
          </div>

          {saved && (
            <span className="px-3 py-1 rounded-full bg-green-50 text-green-700 border border-green-200 text-xs font-medium">
              Salvo
            </span>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-6 items-center">
          <div className="rounded-xl border border-alvinegro-border bg-alvinegro-light min-h-48 flex items-center justify-center">
            <img
              src={BRAND_LOGO_URL}
              alt={BRAND_NAME}
              className="object-contain"
              style={{ width: draftSize, height: draftSize }}
            />
          </div>

          <div className="space-y-5">
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="text-sm font-medium text-alvinegro-dark">
                  Tamanho da logo
                </label>
                <span className="text-sm font-semibold text-alvinegro-black">
                  {draftSize}px
                </span>
              </div>

              <input
                type="range"
                min="40"
                max="120"
                value={draftSize}
                onChange={(event) => updateSize(Number(event.target.value))}
                className="w-full accent-alvinegro-black"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-alvinegro-dark mb-1">
                Valor em pixels
              </label>
              <input
                type="number"
                min="40"
                max="120"
                value={draftSize}
                onChange={(event) => updateSize(Number(event.target.value))}
                className="w-32 px-4 py-2 rounded-lg border border-alvinegro-border text-sm focus:outline-none focus:border-alvinegro-black"
              />
            </div>

            <div className="flex flex-wrap items-center gap-3 pt-2">
              <button
                type="button"
                onClick={handleSave}
                className="px-5 py-2.5 rounded-full bg-alvinegro-black text-white text-sm font-medium hover:bg-alvinegro-dark transition-colors cursor-pointer"
              >
                Salvar tamanho
              </button>

              <button
                type="button"
                onClick={handleReset}
                className="px-5 py-2.5 rounded-full border border-alvinegro-border text-sm font-medium text-alvinegro-dark hover:bg-alvinegro-light transition-colors cursor-pointer"
              >
                Restaurar padrão
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
